import rpcClient from './RpcClient';
import { upsertBufferRpc, getBuffersForObjectIdRpc, getGridLayoutBufferByIdRpc, getBufferForDndAreaNameRpc } from '../../__generated__/chirp/com/hubspot/content/grid/layouts/rpc/GridLayoutBuffersRpc';
export function fetchGridLayoutBufferById(id) {
  return rpcClient.call(getGridLayoutBufferByIdRpc, {
    request: {
      id
    }
  });
}
export function upsertGridLayoutBuffer(contentId, gridLayout) {
  return rpcClient.call(upsertBufferRpc, {
    request: {
      objectId: contentId,
      gridLayout
    }
  });
}
export function fetchGridLayoutBuffersForContentId(contentId) {
  return rpcClient.call(getBuffersForObjectIdRpc, {
    request: {
      objectId: contentId
    }
  });
}
export function fetchGridLayoutBufferByDndAreaName(contentId, dndAreaName) {
  return rpcClient.call(getBufferForDndAreaNameRpc, {
    request: {
      objectId: contentId,
      dndAreaName
    }
  });
}